import { render } from "./PendingClinicReview.vue?vue&type=template&id=2b9e56ad&scoped=true&lang=pug"
import script from "./PendingClinicReview.vue?vue&type=script&lang=js"
export * from "./PendingClinicReview.vue?vue&type=script&lang=js"

import "./PendingClinicReview.vue?vue&type=style&index=0&id=2b9e56ad&scoped=true&lang=scss"
import "./PendingClinicReview.vue?vue&type=style&index=1&id=2b9e56ad&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9e56ad"]])

export default __exports__